import * as actionTypes from '../actionTypes/Gestures'

export const addGesture = gesture => {
    return {
        type: actionTypes.ADD_GESTURE,
        data: gesture,
    }
}

export const removeGesture = gesture => {
    return {
        type: actionTypes.REMOVE_GESTURE,
        data: gesture,
    }
}
